export default {
  Header: {
    Title: 'Tasks',
    Summary: '#{totalTasks} total · #{dueToday} due today',
  },
  Sections: {
    LastWeek: 'Last week',
    Today: 'Today',
    ThisWeek: 'This Week',
  },
  AddTask: {
    ClientConnections: 'Client Associations',
  },
  TaskItem: {
    UnknownClient: 'Unknown Client',
    MoreClients: '+#{count} more',
  },
  Empty: 'No tasks right now.',
};
